var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('div',{ref:"toolbar",staticClass:"toolbar",staticStyle:{"width":"800px"}}),_c('div',{ref:"editor",staticClass:"text",staticStyle:{"height":"400px","width":"800px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }